export default __webpack_public_path__ + "static/media/Famphy.70b253a0.png";